(() => {
  "use strict";
  const root = window.Shopify?.routes?.root || "/";
  document.addEventListener("change", event => {
    const switcher = event.target?.closest?.("[data-product-collection-switch]");
    if (!switcher || !switcher.value) return;
    const destination = new URL(switcher.value, window.location.href);
    if (destination.origin !== window.location.origin) return;
    window.location.assign(destination.href);
  });
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  if (mobileMenu) {
    const closeMenu = () => { mobileMenu.open = false; };
    mobileMenu.querySelectorAll("nav a").forEach(link => link.addEventListener("click", closeMenu));
    mobileMenu.addEventListener("keydown", event => {
      if (event.key === "Escape") { closeMenu(); mobileMenu.querySelector("summary")?.focus(); }
    });
  }
  const jar = document.querySelector("[data-testid='button-basket-jar']");
  const rig = jar?.querySelector(".reference-jar-lift-rig");
  const mouth = jar?.querySelector(".reference-jar-opening");
  const leftArms = jar?.querySelectorAll(".reference-chef-arms path:nth-child(odd)");
  const rightArms = jar?.querySelectorAll(".reference-chef-arms path:nth-child(even)");
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  let jarFrame = 0;
  let jarPromise = null;
  let queuedLift = false;
  let messageTimer;
  let openingCart = false;
  let cartQueue = Promise.resolve();
  const visible = () => {
    if (!jar) return false;
    const box = jar.getBoundingClientRect();
    return box.bottom > 0 && box.top < window.innerHeight;
  };
  function pose(value) {
    if (!rig) return;
    rig.style.transform = `translateY(${value}%)`;
    if (mouth) mouth.style.opacity = Math.min(1, Math.max(0, -value / 6));
    leftArms.forEach(path => path.setAttribute("d", `M22 43 Q5 ${42 + value * .4} 22 ${36.333333 + value}`));
    rightArms.forEach(path => path.setAttribute("d", `M78 43 Q95 ${43 + value * .6} 78 ${36.333333 + value}`));
  }
  function liftJar() {
    if (!rig) return Promise.resolve();
    if (jarPromise) return jarPromise;
    const duration = reduced.matches ? 1000 : 1400;
    const height = reduced.matches ? -7 : -26;
    const positions = [0, 1, height, height, -4, 0];
    const times = [0, .12, .38, .64, .86, 1];
    jarPromise = new Promise(resolve => {
      const start = performance.now();
      function step(now) {
        const t = Math.min(1, (now - start) / duration);
        let i = 0;
        while (i < times.length - 2 && t > times[i + 1]) i++;
        const local = Math.max(0, Math.min(1, (t - times[i]) / (times[i + 1] - times[i])));
        const eased = (1 - Math.cos(Math.PI * local)) / 2;
        pose(positions[i] + (positions[i + 1] - positions[i]) * eased);
        if (t < 1) jarFrame = requestAnimationFrame(step);
        else {
          pose(0);
          jarPromise = null;
          resolve();
        }
      }
      jarFrame = requestAnimationFrame(step);
    });
    return jarPromise;
  }
  function showMessage(message) {
    const box = document.querySelector(".cart-message");
    if (!box) return;
    clearTimeout(messageTimer);
    box.textContent = message;
    box.hidden = false;
    messageTimer = setTimeout(() => { box.hidden = true; }, 6500);
  }
  const money = (cents, currency) => new Intl.NumberFormat(
    document.body.dataset.locale || "en",
    { style: "currency", currency: currency || document.body.dataset.currency || "CAD" }
  ).format(cents / 100);
  async function updateCartLine(lineKey, quantity, input, button) {
    if (button.disabled) return;
    const oldLabel = button.textContent;
    const previousQuantity = input.dataset.currentQuantity || input.value;
    button.disabled = true;
    input.disabled = true;
    button.textContent = "Updating…";
    const previous = cartQueue;
    let release;
    cartQueue = new Promise(resolve => { release = resolve; });
    await previous;
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      const cart = await response.json();
      if (!response.ok || cart.status >= 400) {
        throw new Error(typeof cart.description === "string" ? cart.description : "The cart quantity could not be updated. Please try again.");
      }
      updateJar(cart);
      showMessage(quantity === 0 ? "Item removed from your cart." : "Cart quantity updated.");
    } catch (error) {
      input.value = previousQuantity;
      showMessage(error instanceof TypeError
        ? "We could not confirm the cart update. Review your cart before trying again."
        : error instanceof Error ? error.message : "The cart quantity could not be updated. Please try again.");
      await refreshJar();
    } finally {
      button.disabled = false;
      input.disabled = false;
      button.textContent = oldLabel;
      release();
    }
  }
  function bindCartQuantityEditor(editor, input, button) {
    if (editor.dataset.bound === "true" || !input || !button) return;
    editor.dataset.bound = "true";
    const submit = event => {
      event.preventDefault();
      const quantity = Number(input.value);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 999) {
        input.value = input.dataset.currentQuantity || "1";
        showMessage("Enter a whole quantity from 0 to 999.");
        return;
      }
      return updateCartLine(editor.dataset.cartLineKey, quantity, input, button);
    };
    button.addEventListener("click", submit);
    input.addEventListener("keydown", event => {
      if (event.key === "Enter") submit(event);
    });
  }
  function bindCartQuantityEditors(container) {
    container.querySelectorAll("[data-cart-quantity-edit]").forEach(editor => {
      bindCartQuantityEditor(
        editor,
        editor.querySelector("[data-cart-quantity-input]"),
        editor.querySelector("[data-cart-quantity-update]")
      );
    });
  }
  function updateCartPreview(cart) {
    const preview = document.querySelector("[data-cart-preview]");
    if (!preview) return;
    const bagCount = Array.isArray(cart.items)
      ? cart.items.reduce((total, item) => item.properties?.["_Jazzis surcharge item"] === "true" ? total : total + (Number(item.quantity) || 0), 0)
      : 0;
    const count = preview.querySelector("[data-cart-count]");
    if (count) {
      count.textContent = String(bagCount);
      count.setAttribute("aria-label", `${bagCount} candy bags in cart`);
    }
    const total = preview.querySelector("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price ?? 0, cart.currency);
    const items = preview.querySelector("[data-cart-items]");
    if (!items) return;
    items.replaceChildren();
    if (!Array.isArray(cart.items) || cart.items.length === 0) {
      const empty = document.createElement("div");
      empty.className = "basket-empty";
      const message = document.createElement("span");
      message.textContent = "You haven’t added any bags yet.";
      empty.append(message);
      items.append(empty);
      return;
    }
    const list = document.createElement("div");
    list.className = "bag-list";
    cart.items.forEach((item, index) => {
      const card = document.createElement("article");
      card.className = "bag-card";
      const heading = document.createElement("div");
      heading.className = "bag-card-head";
      const productInfo = document.createElement("div");
      const productName = document.createElement("strong");
      productName.textContent = item.product_title || item.title || "Pick A Mix bag";
      productInfo.append(productName);
      if (item.variant_title && item.variant_title !== "Default Title") {
        const variant = document.createElement("span");
        variant.textContent = item.variant_title;
        productInfo.append(variant);
      }
      const linePrice = document.createElement("strong");
      linePrice.textContent = money(item.final_line_price ?? item.line_price ?? 0, cart.currency);
      heading.append(productInfo, linePrice);
      card.append(heading);
      for (const [name, value] of Object.entries(item.properties || {})) {
        if (name.startsWith("_") || value == null || value === "") continue;
        const property = document.createElement("p");
        property.className = "basket-line-property";
        property.textContent = `${name}: ${value}`;
        card.append(property);
      }
      const actions = document.createElement("div");
      actions.className = "bag-card-actions";
      const quantityEdit = document.createElement("div");
      quantityEdit.className = "bag-quantity-edit";
      quantityEdit.dataset.cartQuantityEdit = "";
      quantityEdit.dataset.cartLineKey = item.key || String(item.id || "");
      const quantityLabel = document.createElement("label");
      quantityLabel.textContent = "Qty ";
      const quantityInput = document.createElement("input");
      quantityInput.type = "number";
      quantityInput.min = "0";
      quantityInput.max = "999";
      quantityInput.value = String(item.quantity);
      quantityInput.dataset.cartQuantityInput = "";
      quantityInput.dataset.currentQuantity = String(item.quantity);
      quantityInput.setAttribute("aria-label", `Quantity for ${item.product_title || item.title || "Pick A Mix bag"}`);
      quantityLabel.append(quantityInput);
      const updateQuantity = document.createElement("button");
      updateQuantity.type = "button";
      updateQuantity.textContent = "Update";
      updateQuantity.dataset.cartQuantityUpdate = "";
      quantityEdit.append(quantityLabel, updateQuantity);
      bindCartQuantityEditor(quantityEdit, quantityInput, updateQuantity);
      const remove = document.createElement("a");
      remove.className = "bag-remove";
      remove.href = `${root}cart/change?line=${index + 1}&quantity=0`;
      remove.dataset.cartRemove = "";
      remove.dataset.cartLineKey = item.key || String(item.id || "");
      remove.textContent = "Remove";
      actions.append(quantityEdit, remove);
      bindCartQuantityEditors(quantityEdit.parentNode || actions);
      card.append(actions);
      list.append(card);
    });
    items.append(list);
  }
  function updateJar(cart) {
    updateCartPreview(cart);
    const total = money(cart.total_price, cart.currency);
    const label = `${cart.item_count} ${cart.item_count === 1 ? "Item" : "Items"} | ${total}`;
    const summary = document.querySelector("[data-testid='text-basket-summary']");
    if (summary) summary.textContent = label;
    jar?.setAttribute("aria-label", `View cart, ${label}`);
  }
  document.querySelectorAll("[data-cart-preview]").forEach(preview => {
    const items = preview.querySelector("[data-cart-items]");
    if (items) bindCartQuantityEditors(items);
    preview.addEventListener("click", event => {
      const remove = event.target.closest("[data-cart-remove]");
      if (!remove || !preview.contains(remove)) return;
      event.preventDefault();
      const input = remove.closest(".bag-card")?.querySelector("[data-cart-quantity-input]");
      if (!input || input.disabled || remove.disabled) return;
      updateCartLine(remove.dataset.cartLineKey, 0, input, remove);
    });
  });
  document.addEventListener("jazzis:cart-updated", event => {
    updateJar(event.detail);
    showMessage("Your custom bag is in your cart. Open your cart to review it.");
    if (visible()) liftJar(); else queuedLift = true;
  });
  document.addEventListener("jazzis:cart-changed", event => {
    updateJar(event.detail);
  });
  document.addEventListener("jazzis:cart-stale", () => {
    jar?.setAttribute("aria-label", "Review your updated cart");
  });
  const openCartFromTrigger = async (event, animateJar = false) => {
    // Retain an ordinary cart link for no-JS and modified-click navigation.
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (openingCart) return;
    openingCart = true;
    try {
      if (animateJar) await liftJar();
      const drawer = document.querySelector("[data-cart-drawer]");
      if (drawer && typeof drawer.showModal === "function") {
        if (drawer.open) {
          openingCart = false;
          document.dispatchEvent(new CustomEvent("jazzis:cart-drawer-open"));
          return;
        }
        drawer.addEventListener("close", () => { openingCart = false; }, { once: true });
        drawer.showModal();
        document.dispatchEvent(new CustomEvent("jazzis:cart-drawer-open"));
        return;
      }
    } catch (error) {
      console.error("Could not open the cart drawer; opening the cart page instead.", error);
    }
    openingCart = false;
    window.location.assign(document.body.dataset.cartUrl || `${root}cart`);
  };
  jar?.addEventListener("click", event => openCartFromTrigger(event, true));
  document.querySelector(".mobile-jar-link")?.addEventListener("click", event => openCartFromTrigger(event));
  jar?.addEventListener("pointerenter", event => {
    if (event.pointerType === "mouse") liftJar();
  });
  if (jar && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && queuedLift) {
        queuedLift = false;
        liftJar();
      }
    }).observe(jar);
  } else {
    window.addEventListener("scroll", () => {
      if (queuedLift && visible()) { queuedLift = false; liftJar(); }
    }, { passive: true });
  }
  const chef = document.querySelector(".reference-candy-wave-trigger");
  const glove = document.querySelector(".reference-candy-wave-hand");
  function wave() {
    if (!glove) return;
    glove.classList.remove("is-waving");
    void glove.offsetWidth;
    glove.classList.add("is-waving");
  }
  chef?.addEventListener("click", wave);
  chef?.addEventListener("focus", wave);
  chef?.addEventListener("pointerenter", event => { if (event.pointerType === "mouse") wave(); });

  // All prices, inventory and cart contents come from Shopify, never localStorage.
  document.querySelectorAll(".sweet-add-form").forEach(form => {
    form.addEventListener("submit", async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (form.dataset.busy === "true") return;
      const button = form.querySelector("[type='submit']");
      const feedback = form.querySelector(".form-feedback");
      const oldLabel = button?.textContent;
      form.dataset.busy = "true";
      form.setAttribute("aria-busy", "true");
      if (button) { button.disabled = true; button.textContent = "Adding…"; }
      if (feedback) feedback.textContent = "";
      const previous = cartQueue;
      let release;
      cartQueue = new Promise(resolve => { release = resolve; });
      await previous;
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST", body: new FormData(form), headers: { Accept: "application/json" }
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) {
          throw new Error(typeof data.description === "string" ? data.description : "This candy could not be added. Please check its availability.");
        }
        added = true;
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: "application/json" }, cache: "no-store" });
        if (!cartResponse.ok) throw new Error("Added to your cart, but its total could not refresh. Open your cart to see the latest total.");
        const cart = await cartResponse.json();
        updateJar(cart);
        document.dispatchEvent(new CustomEvent("jazzis:cart-added", { detail: cart }));
        if (feedback) feedback.textContent = "Added to your cart.";
        showMessage("Added to your cart. Open your cart to review your candy.");
        if (visible()) liftJar(); else queuedLift = true;
      } catch (error) {
        const message = error instanceof TypeError
          ? "We could not confirm the cart update. Open your cart before trying again so you do not add the same item twice."
          : error instanceof Error ? error.message : "Something went wrong. Please try again.";
        if (feedback) feedback.textContent = message;
        showMessage(message);
        // Do not silently retry: an earlier request may already have added the item.
        if (added && jar) jar.setAttribute("aria-label", "Review your updated cart");
      } finally {
        delete form.dataset.busy;
        form.removeAttribute("aria-busy");
        if (button) { button.disabled = false; button.textContent = oldLabel; }
        release();
      }
    });
    const variant = form.querySelector("select[name='id']");
    variant?.addEventListener("change", () => {
      const selected = variant.selectedOptions[0];
      const price = form.closest(".product-detail")?.querySelector("[data-variant-price]");
      if (price) price.textContent = selected.dataset.price;
      const detail = form.closest(".product-detail");
      const christmasPhoto = detail?.querySelector("[data-christmas-product-photo]");
      const christmasPhotoEmpty = detail?.querySelector("[data-christmas-photo-empty]");
      if (christmasPhoto) {
        const src = selected.dataset.christmasPhoto;
        christmasPhoto.hidden = !src;
        if (src) christmasPhoto.src = src;
        if (christmasPhotoEmpty) christmasPhotoEmpty.hidden = !!src;
      }
      const button = form.querySelector("[type='submit']");
      if (button) {
        button.disabled = selected.dataset.available !== "true";
        button.textContent = button.disabled ? "Sold out" : "Add to cart";
      }
    });
  });
  // Back/forward cache restores and other tabs can change Shopify's cart.
  async function refreshJar() {
    try {
      const response = await fetch(`${root}cart.js`, { cache: "no-store", headers: { Accept: "application/json" } });
      if (response.ok) updateJar(await response.json());
    } catch { /* Keep the last server-rendered summary until the next refresh. */ }
  }
  window.addEventListener("pageshow", event => { if (event.persisted) refreshJar(); });
  document.addEventListener("visibilitychange", () => { if (!document.hidden) refreshJar(); });
  window.addEventListener("pagehide", () => { cancelAnimationFrame(jarFrame); });

  document.querySelectorAll("[data-tiktok-live-player]").forEach(player => {
    const frame = player.querySelector("iframe");
    if (!frame) return;
    window.addEventListener("message", event => {
      if (event.origin !== "https://www.tiktok.com" || event.source !== frame.contentWindow) return;
      const message = event.data;
      if (
        message?.["x-tiktok-player"] === true &&
        message.type === "onStateChange" &&
        Number(message.value) === 1
      ) {
        player.classList.add("is-playing");
      }
    });
  });

})();
